import type { CSSProperties } from 'react';
import { Alignment } from 'root/consts';
import { getAlignmentText } from 'root/utils/alignment';
import { Preset } from 'root/utils/presets';
import { useGetAlignment } from 'root/hooks/useGetAlignment';

export const useGetMenuTextAlignment = (preset: Preset) => {
  const gridMenuAlignment = useGetAlignment('gridMenuAlignment');
  const columnsMenuAlignment = useGetAlignment('columnsMenuAlignment');
  const sideBySideMenuAlignment = useGetAlignment('sideBySideMenuAlignment');

  const textAlignCssMap: Record<Preset, string> = {
    [Preset.Grid]: gridMenuAlignment,
    [Preset.Columns]: columnsMenuAlignment,
    [Preset.Center]: getAlignmentText(Alignment.Center),
    [Preset.SideBySide]: sideBySideMenuAlignment,
  };

  return { textAlign: textAlignCssMap[preset] as CSSProperties['textAlign'] };
};
